/**
 *
 * @module httpMethod
 * @see https://github.com/STRML/keyMirror
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef HttpMethod
 * @type {Object}
 *
 * @property {String} GET
 * @property {String} POST
 * @property {String} DELETE
 * @property {String} PATCH
 * @property {String} PUT
 *
 */

/**
 *
 * @enum
 * @type {HttpMethod}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    GET: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    POST: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    DELETE: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    PATCH: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    PUT: null
});



// WEBPACK FOOTER //
// ./src/services/configuration/httpMethod.js